
import ConfirmBox from "components/shared/VmwareMappingConfirmBox";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Breadcrumb from "components/shared/Breadcrumb";
import vmwareService from "services/admin/masters/vmwareService";
import Select from "react-select";
import MaterialTable from "material-table";
import { toast } from "react-toastify";
import { MAPPING_INPUT_ERROR_TEMPLATE, MAPPING_SELECT_ERROR_TEMPLATE } from "constants/admin/masters/vmware";
import { ERROR_MESSAGE_UNKNOWN, MSG_RECORD_CREATE, MSG_RECORD_DELETE, MSG_RECORD_UNDO_DELETE, MSG_RECORD_UPDATE } from "constants/common";
import {getMatrixId} from "utils/matriceHelpers";
function ManageVmwareBlockStorage() {

  const [breamcrumbs, setBreamcrumbs] = useState([
    { title: "UCP VMware Masters Mapping", url: "/admin/master/ucp-vmware/" },
    { title: "Manage Mapping" },
  ]);

  const serviceObj = new vmwareService();
  const [combineKeyList, setCombineKeyList] = useState([]);
  const [mappingList, setMappingList] = useState([{}]);
  const [blockStorageList, setBlockStorageList] = useState([]);
  const [blockStorageInterfaceList, setBlockStorageInterfaceList] = useState([]);

  const [selectedCombineKeys, setSelectedCombineKeys] = useState([]);
  const [blockStorage, setBlockStorage] = useState("");
  const [blockStorageAccess, setBlockStorageAccess] = useState("");
  const [blockStorageInterface, setBlockStorageInterface] = useState("");
  const [blockStorageMicrocode, setBlockStorageMicrocode] = useState("");
  const [blockStorageFootnote, setBlockStorageFootnote] = useState("");

  const [combineKeyError, setCombineKeyError] = useState("");
  const [blockStorageError, setBlockStorageError] = useState("");
  const [blockStorageMicrocodeError, setBlockStorageMicrocodeError] = useState("");

  const [isFormTouched, setIsFormTouched] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [itemToBeEdited, setItemToBeEdited] = useState(null);
  const [isDeleteConfirmationShown, setIsDeleteConfirmationShown] = useState(false);
  const [isRestoreConfirmationShown, setIsRestoreConfirmationShown] = useState(false);
  const [deleteConfirmationMessage, setDeleteConfirmationMessage] = useState("");
  const [restoreConfirmationMessage, setRestoreConfirmationMessage] = useState("");
  const [itemToBeDeletedOrRestored, setItemToBeDeletedOrRestored] = useState(null);

   const Id = getMatrixId(window.location.pathname);

  useEffect(() => getMappingData(), []);

  useEffect(() => {
    // re-validate form upon field value change if form is touched
    if (isFormTouched) {
      validateMappingForm();
    }
  }, [selectedCombineKeys, blockStorage, blockStorageAccess, blockStorageInterface, blockStorageMicrocode, blockStorageFootnote]);

  useEffect(() => {
    // populate details of item to be edited
    if (isEditMode) {
      populateItemDetailsToEdit();
    }
  }, [itemToBeEdited?.record_details?.id]);

  const getMappingData = () => {
    serviceObj.getAllInitialData(Id)
      .then((response) => {
        setMappingList(response?.vmware_block_storage_mapping_list);
        extractAndSetCombineKeys(response?.vmware_combine_keys);
        extractBlockStorageInterface(response?.block_storage_interface_master_drop_list);
        extractBlockStorage(response?.block_storage_master_drop_list);
      })
      .catch((error) => {
        toast.error(ERROR_MESSAGE_UNKNOWN);
      });
  };

  // setting Combine keys
  const extractAndSetCombineKeys = (dataList) => {
    const combineKeyList = dataList?.map((item) => ({
      id: item?.id,
      value: item?.combine_key,
      label: item?.combine_key,
      disabled: item?.disabled
    }));
    setCombineKeyList(combineKeyList);
  };

  const extractBlockStorageInterface = (dataList) => {
    const interfaceList = dataList?.map((item) => ({
      id: item?.id,
      value: item?.name,
      label: item?.name,
      disabled: item?.disabled
    }));
    setBlockStorageInterfaceList(interfaceList);
  };

  const extractBlockStorage = (dataList) => {
    const storageList = dataList?.map((item) => ({
      id: item?.id,
      value: item?.name,
      label: item?.name,
      disabled: item?.disabled
    }));
    setBlockStorageList(storageList);
  };

  // reset form values, error messages, form state, edit mode, target edit item
  const resetForm = () => {
    resetFormValues();
    resetErrorMessages();
    setIsFormTouched(false);
    setIsEditMode(false);
    setItemToBeEdited(null);
  };

  // append offending field name in error message
  const getSelectErrorMessageFor = (fieldName) => {
    return MAPPING_SELECT_ERROR_TEMPLATE?.replace("_FIELD_NAME_", fieldName);
  };

  // append offending field name in error message
  const getInputErrorMessageFor = (fieldName) => {
    return MAPPING_INPUT_ERROR_TEMPLATE?.replace("_FIELD_NAME_", fieldName);
  };

  // validate fields and set or reset error message
  const validateMappingForm = () => {
    let isFormValid = true;
    if (!selectedCombineKeys?.length) {
      setCombineKeyError(getSelectErrorMessageFor("Combine Key"));
      isFormValid = false;
    } else {
      setCombineKeyError("");
    }

    if (!blockStorage) {
      setBlockStorageError(getSelectErrorMessageFor("Block Storage"));
      isFormValid = false;
    } else {
      setBlockStorageError("");
    }

    if (!blockStorageMicrocode) {
      setBlockStorageMicrocodeError(getInputErrorMessageFor("Block Storage Microcode/Software"));
      isFormValid = false;
    } else {
      setBlockStorageMicrocodeError("");
    }

    return isFormValid;
  };

  // reset field values
  const resetFormValues = () => {
    setSelectedCombineKeys([]);
    setBlockStorage(null);
    setBlockStorageAccess("");
    setBlockStorageInterface(null);
    setBlockStorageMicrocode("");
    setBlockStorageFootnote("");
  };

  // reset error messages
  const resetErrorMessages = () => {
    setCombineKeyError("");
    setBlockStorageError("");
    setBlockStorageMicrocodeError("");
  };

  // api call for adding new mapping
  const addMapping = (e) => {
    e.preventDefault();
    setIsFormTouched(true);
    const isFormValid = validateMappingForm();

    // call POST api if form is valid
    if (isFormValid) {
      let payload = {
        block_storage_id: blockStorage?.id,
        block_storage_access: blockStorageAccess,
        block_storage_interface_id: blockStorageInterface?.id,
        block_storage_microcode_software: blockStorageMicrocode,
        block_storage_footnote: blockStorageFootnote,
        vmware_combine_keys: selectedCombineKeys?.map(key => key?.id)
      };
      serviceObj.createBlockStorageMapping(payload).then((response) => {
        toast.success(MSG_RECORD_CREATE);
        getMappingData();
        resetForm();
      })
      .catch(error => toast.error(ERROR_MESSAGE_UNKNOWN));
    }
  };

  // process target item for editing
  const populateItemDetailsToEdit = () => {
    const combineKeysToEdit = itemToBeEdited?.vmware_combine_keys?.map((item) => ({
      id: item?.id,
      value: item?.combine_key,
      label: item?.combine_key,
      disabled: item?.disabled
    }));
    const storageToEdit = {
      id: itemToBeEdited?.record_details?.block_storage_id,
      value: itemToBeEdited?.record_details?.block_storage,
      label: itemToBeEdited?.record_details?.block_storage,
    };
    const interfaceToEdit = {
      id: itemToBeEdited?.record_details?.block_storage_interface_id,
      value: itemToBeEdited?.record_details?.block_storage_interface,
      label: itemToBeEdited?.record_details?.block_storage_interface,
      disabled: itemToBeEdited?.record_details?.disabled
    };
    setSelectedCombineKeys(combineKeysToEdit);
    setBlockStorage(storageToEdit);
    setBlockStorageMicrocode(itemToBeEdited?.record_details?.block_storage_microcode_software);
    setBlockStorageAccess(itemToBeEdited?.record_details?.block_storage_access);
    setBlockStorageInterface(interfaceToEdit);
    setBlockStorageFootnote(itemToBeEdited?.record_details?.block_storage_footnote);
  };

  // fetch details of item to be edited
  const editMapping = (data) => {
    setIsEditMode(true);
    // fetch details of item to edit
    serviceObj.getBlockStorageKeyDetails(data?.id).then((response) => {
      setItemToBeEdited(response);
    })
      .catch(error => toast.error(ERROR_MESSAGE_UNKNOWN));
  };

  // update 
  const updateMappingById = (e) => {
    e.preventDefault();
    setIsFormTouched(true);
    const isFormValid = validateMappingForm();
    if (isFormValid) {
      const payload = {
        block_storage_id: blockStorage?.id,
        block_storage_access: blockStorageAccess,
        block_storage_interface_id: blockStorageInterface?.id,
        block_storage_microcode_software: blockStorageMicrocode,
        block_storage_footnote: blockStorageFootnote,
        vmware_combine_keys: selectedCombineKeys?.map(key => key?.id)
      };
      const targetItemId = itemToBeEdited?.record_details?.id;
      serviceObj.updateBlockStorageMapping(targetItemId, payload).then((response) => {
        toast.success(MSG_RECORD_UPDATE);
        getMappingData();
        resetForm();
      })
        .catch(error => toast.error(ERROR_MESSAGE_UNKNOWN)
        );
    }
  };

  // delete or restore mapping
  const deleteOrRestoreMappingById = () => {
    const { id, is_deleted } = itemToBeDeletedOrRestored;
    serviceObj.deleteBlockStorageMapping(id)
      .then((response) => {
        // show deleted or restored message based on is_deleted property
        if (is_deleted) {
          toast.success(MSG_RECORD_UNDO_DELETE);
          setIsRestoreConfirmationShown(false);
          setRestoreConfirmationMessage("")
        } else {
          toast.success(MSG_RECORD_DELETE);
          setIsDeleteConfirmationShown(false)
          setDeleteConfirmationMessage("");
        }
        resetForm();
        setItemToBeDeletedOrRestored(null);
      })
      .catch((error) => {
        toast.error(ERROR_MESSAGE_UNKNOWN);
        setIsDeleteConfirmationShown(false)
        setDeleteConfirmationMessage("");
        setItemToBeDeletedOrRestored(null);
      })
      .finally(() => getMappingData());
  };

  // show delete warning confirmation popup
  const deleteMappingHandler = (rowData) => {
    setIsDeleteConfirmationShown(true);
    setItemToBeDeletedOrRestored(rowData);
    setDeleteConfirmationMessage(`Are you sure you want to remove ${rowData?.block_storage} with Combine Key ${rowData?.vmware_combine_key}?`)
  };

  // show restore warning confirmation popup
  const restoreMappingHandler = (rowData) => {
    setIsRestoreConfirmationShown(true);
    setItemToBeDeletedOrRestored(rowData);
    setRestoreConfirmationMessage(`Are you sure you want to restore ${rowData?.block_storage} with Combine Key ${rowData?.vmware_combine_key}?`);
  };

  // hide confirmation message and reset target item
  const cancelDeleteItem = () => {
    setIsDeleteConfirmationShown(false);
    setItemToBeDeletedOrRestored(null);
  };

  // hide confirmation message and reset target item
  const cancelRestoreItem = () => {
    setIsRestoreConfirmationShown(false);
    setItemToBeDeletedOrRestored(null);
    setRestoreConfirmationMessage("")
  };

  return (
    <div className="form-wrap mt-3">
      <Breadcrumb data={breamcrumbs} disableEditTitle={true} />
      {isDeleteConfirmationShown &&
        <ConfirmBox
          actionHandler={deleteOrRestoreMappingById}
          handleSubmit={deleteOrRestoreMappingById}
          cancelDeleteItem={cancelDeleteItem}
        >
          {deleteConfirmationMessage}
        </ConfirmBox>
      }
      {isRestoreConfirmationShown &&
        <ConfirmBox
          actionHandler={deleteOrRestoreMappingById}
          handleSubmit={deleteOrRestoreMappingById}
          cancelDeleteItem={cancelRestoreItem}
        >
          {restoreConfirmationMessage}
        </ConfirmBox>
      }
      <div className="form-group d-flex">
        <div className="col-sm-4">
          <form>
            <div className="row pl-2 pb-1">
              <div className="col-sm-11">
                {/* Combine key */}
                <div className="form-group">
                  <label htmlFor={""} className="mr-sm-2 mt-2"><b>VMware Combine Key</b></label>
                  {/* add multi select dropdown */}
                  <Select
                    isMulti
                    name="Combine Key"
                    options={combineKeyList}
                    classNamePrefix="select"
                    onChange={selectedKeys => setSelectedCombineKeys(selectedKeys)}
                    value={selectedCombineKeys}
                    isOptionDisabled={option => option.disabled}
                  />
                  {
                    combineKeyError
                    &&
                    <div className="col-sm-10 mb-2 text-danger">{combineKeyError}</div>
                  }
                </div>
                {/* Block Storage */}
                <div className="form-group">
                  <label htmlFor={"blockStorage"} className="mr-sm-2"><b>Block Storage</b></label>
                  <Select
                    name="blockStorage"
                    options={blockStorageList}
                    classNamePrefix="select"
                    onChange={selectedKeys => setBlockStorage(selectedKeys)}
                    value={blockStorage}
                    isOptionDisabled={option => option.disabled}
                    isDisabled={isEditMode}
                  />
                  {blockStorageError
                    &&
                    <div className="col-sm-10 mb-2 text-danger">{blockStorageError}</div>
                  }
                </div>
                {/* Block Storage Microcode */}
                <div className="form-group">
                  <label htmlFor={"blockStorageMicrocode"} className="mr-sm-2"><b>Block Storage Microcode/Software</b></label>
                  <input type="text"
                    id="blockStorageMicrocode"
                    className="form-control"
                    maxLength="60"
                    name="blockStorageMicrocode"
                    value={blockStorageMicrocode}
                    onChange={(e) => setBlockStorageMicrocode(e.target.value)}
                    placeholder="Enter Block Storage Microcode/Software"
                  />
                  {blockStorageMicrocodeError
                    &&
                    <div className="col-sm-10 mb-2 text-danger">{blockStorageMicrocodeError}</div>
                  }
                </div>
                {/* Block Storage Access */}
                <div className="form-group">
                  <label htmlFor={"blockStorageAccess"} className="mr-sm-2"><b>Block Storage Access</b></label>
                  <input type="text"
                    id="blockStorageAccess"
                    className="form-control"
                    maxLength="60"
                    name="blockStorageAccess"
                    value={blockStorageAccess}
                    onChange={(e) => setBlockStorageAccess(e.target.value)}
                    placeholder="Enter Block Storage Access"
                  />
                </div>
                {/* Block Storage Interface */}
                <div className="form-group">
                  <label htmlFor={"blockStorageInterface"} className="mr-sm-2"><b>Block Storage Interface</b></label>
                  <Select
                    name="blockStorageInterface"
                    options={blockStorageInterfaceList}
                    classNamePrefix="select"
                    onChange={selectedKeys => setBlockStorageInterface(selectedKeys)}
                    value={blockStorageInterface}
                    isOptionDisabled={option => option.disabled}
                    isDisabled={isEditMode}
                  />
                </div>
                {/* Block Storage Footnote */}
                <div className="form-group">
                  <label htmlFor={"blockStorageFootnote"} className="mr-sm-2"><b>Block Storage Footnote</b></label>
                  <input type="text"
                    id="blockStorageFootnote"
                    className="form-control"
                    maxLength="60"
                    name="blockStorageFootnote"
                    value={blockStorageFootnote}
                    onChange={(e) => setBlockStorageFootnote(e.target.value)}
                    placeholder="Enter Block Storage Footnote"
                  />
                </div>
              </div>
            </div>

            <div className="col-sm-12">
              <button type="reset"
                onClick={resetForm}
                className="btn btn-md btn-light btn-link submit-btn-inline mr-sm-2">
                <i className="fa fa-refresh"></i> Reset</button>
              <button
                type="submit"
                className="btn btn-md btn-dark submit-btn-inline"
                onClick={isEditMode ? updateMappingById : addMapping}
              >
                {isEditMode ? "Update" : "Add"}
              </button>
            </div>
          </form>
        </div>
        <div className="col-sm-8">
          <MaterialTable
            title="Block Storage Mappings"
            columns={[
              { title: "Combine Key", field: "vmware_combine_key" },
              { title: "Block Storage", field: "block_storage" },
              { title: "Block Storage Microcode", field: "block_storage_microcode_software" },
              { title: "Block Storage Access", field: "block_storage_access" },
              { title: "Block Storage Interface", field: "block_storage_interface" },
              { title: "Block Storage Footnote", field: "block_storage_footnote" }
            ]}
            data={mappingList}
            options={{
              headerStyle: {
                backgroundColor: "#e9ecef",
              },
              actionsColumnIndex: -1,
              selection: false,
              search: true,
              maxBodyHeight: 400
            }}

            localization={{
              header: {
                actions: "Actions",
              },
            }}
            actions={
              [
                (rowData) => ({
                  icon: "edit",
                  tooltip: !rowData.is_deleted && "Edit Record",
                  onClick: (e, data) => editMapping(data),
                  hidden: !rowData?.id || rowData.is_deleted // display action only if any valid item is present
                }),
                (rowData) => ({
                  icon: rowData.is_deleted ? "undo" : "delete",
                  tooltip: rowData.is_deleted ? "Undo Deleted Record" : "Delete Record",
                  onClick: (e, data) => rowData.is_deleted ? restoreMappingHandler(data) : deleteMappingHandler(data),
                  hidden: !rowData?.id // display action only if any valid item is present
                })
              ]}
          />
        </div>
      </div>
    </div>
  )
}

export default ManageVmwareBlockStorage;